import React from 'react';

const Padlock: React.FC = () => {
    return (
      <svg
        width="10"
        height="14"
        viewBox="0 0 10 14"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.53125 5.375H8.125V3.75C8.125 1.95758 6.66742 0.5 4.875 0.5C3.08258 0.5 1.625 1.95758 1.625 3.75V5.375H1.21875C0.547089 5.375 0 5.92149 0 6.59375V12.2812C0 12.9535 0.547089 13.5 1.21875 13.5H8.53125C9.20291 13.5 9.75 12.9535 9.75 12.2812V6.59375C9.75 5.92149 9.20291 5.375 8.53125 5.375ZM2.70837 3.75C2.70837 2.55505 3.68005 1.58337 4.875 1.58337C6.06995 1.58337 7.04163 2.55505 7.04163 3.75V5.375H2.70837V3.75Z"
        />
      </svg>
    );
}

export default Padlock;
